export const generalSection = () => [
  {
    field: 'type',
    type: 'text',
    size: 'half',
    required: false,
    disabled: true,
  },
  {
    field: 'description',
    type: 'text',
    placeholder: 'Enter description about the image',
    required: false,
    disabled: true,
  },
];

export const initialValues = {
  description: '',
  name: '',
  data: '',
};
